import { ClaimType, useClaimTypesProperties } from 'all-in-one-shared-api';
import { useProfileInfoContext } from 'contexts/profileInfo';
import { useKeycloakReady } from 'hooks';
import { useEffect } from 'react';

export const useGetClaimTypesByMemberTypes = (selectedPatientMemberTypes: string[]): { claimTypes: ClaimType[] } => {
  const { state: profileInfo } = useProfileInfoContext();
  const { token, ready } = useKeycloakReady();

  const patientMemberTypes = selectedPatientMemberTypes.toString();

  const { shouldFetch: shouldFetchClaimTypesProperties, data: claimTypesPropertiesData } = useClaimTypesProperties(
    {
      key: 'getClaimTypesProperties',
      params: {
        policyNumber: profileInfo?.policyNumber,
        memberId: profileInfo?.memberId,
        patientMemberTypes,
      },
    },
    token ?? '',
    profileInfo?.policyNumber ?? '',
    profileInfo?.memberId ?? '',
    patientMemberTypes,
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
    },
  );

  useEffect(() => {
    shouldFetchClaimTypesProperties(ready && profileInfo !== undefined && patientMemberTypes !== undefined);
  }, [ready, patientMemberTypes, profileInfo, shouldFetchClaimTypesProperties, claimTypesPropertiesData]);

  return { claimTypes: claimTypesPropertiesData?.claimTypes ?? [] };
};
